import type { Theme } from "@mui/system";
import type { ComicDrawerProps } from "@vapor/react-contrib-tax-compliance/ComicDrawer/ComicDrawer";
import { useMediaQuery } from "@vapor/react-material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TaxSubmissionUpload } from "../components/tax-submission-upload/TaxSubmissionUpload";

export const useUploadDrawer = (
    open: boolean,
    setOpen: (open: boolean) => void,
): ComicDrawerProps | undefined => {
    const { t } = useTranslation();
    const isXlScreen = useMediaQuery((theme: Theme) =>
        theme.breakpoints.up(theme.breakpoints.values.xl),
    );

    return useMemo(() => {
        if (!open) return undefined;

        return {
            content: (
                <TaxSubmissionUpload
                    onClickCancelButton={() => setOpen(false)}
                    onUploadTaxSubmission={() => setOpen(false)}
                />
            ),
            headerTitle: t("views.home.actions.upload_taxSubmission"),
            onClickCloseButton: () => setOpen(false),
            open: true,
            width: isXlScreen ? "60%" : "70%",
        };
    }, [open, setOpen, t, isXlScreen]);
};
